export const msalConfig = {
    auth: {
      clientId: "9e230910-1280-481b-ba67-d5d2a6c96c8f",
      authority: "https://login.microsoftonline.com/common",
      redirectUri: "https://ematch.soyentel.com/",
      postLogoutRedirectUri:"https://www.entel.cl/"
    }
};
